import CashCollectionDepositRequestBase from './base/CashCollectionDepositRequestBase';

/**
 * @class CashCollectionDepositRequest
 * @extends CashCollectionDepositRequestBase
 */
class CashCollectionDepositRequest extends CashCollectionDepositRequestBase {

}

export default CashCollectionDepositRequest;
